import Vue from 'vue'

export const UserOrderApi = {
  async fetch(userId) {
    try {
      const response = await Vue.axios.get(`/api/v3/users/${userId}/orders`);

      if(response.status == 200 || response.status == 304) {
        return response.data.orders;
      } else {
        return []
      }
    } catch (e) {
      console.log(e)
    }
  }
};